import React from 'react';
import { Select } from 'antd';
import Field from '../../../../shared/ui/Field';
import {
  useFieldController,
  useFormMethods,
} from '../../../../../../helpers/formManager';
import { fieldNames, actionsEnum } from '../../constants';
import styles from './index.module.scss';

const options = [
  { label: 'Установить', value: actionsEnum.SET },
  { label: 'Очистить', value: actionsEnum.CLEAR },
];

const unregisteredClearNames = [fieldNames.cleanableDateEntity];
const unregisteredSetNames = [
  fieldNames.dateSetting,
  fieldNames.startDate,
  fieldNames.endDate,
];

const SelectAction = () => {
  const { field, fieldState } = useFieldController({
    name: fieldNames.action,
    rules: { required: 'Выберите действие' },
  });

  const { unregister } = useFormMethods();

  const handleChange = (value) => {
    if (value === actionsEnum.CLEAR) {
      unregister(unregisteredSetNames);
    } else if (value === actionsEnum.SET) {
      unregister(unregisteredClearNames);
    }

    field.onChange(value);
  };

  return (
    <Field.Memoized
      type={Field.types.select}
      formItemLabel="Действие"
      required
      value={field.value}
      errorMessage={fieldState.error?.message}
      placeholder="Выбрать из списка"
      onChange={handleChange}
      rootCN={styles.root}
      style={{ width: '100%' }}
    >
      {options.map((option) => (
        <Select.Option key={option.value} value={option.value}>
          {option.label}
        </Select.Option>
      ))}
    </Field.Memoized>
  );
};

export default SelectAction;
